<template>
    <v-container fluid class="admin-page">
        <!-- Header -->
        <div class="page-header">
            <div>
                <p class="page-kicker">Mon espace</p>
                <h1 class="page-title">Mon compte</h1>
                <p class="page-subtitle" v-if="user.email">{{ user.email }}</p>
            </div>
        </div>

        <!-- data -->
        <v-row>
            <v-col cols="12" xl="4" lg="6" md="6">
                <user-card :user="user"></user-card>
                <div class="my-4"></div>
                <user-info :user="user"></user-info>
            </v-col>

            <v-col cols="12" xl="8" lg="6" md="6">
                <user-password :userId="user.id" :isLoading="isLoading" @load="loadingChange"></user-password>
            </v-col>
        </v-row>
        <v-overlay :model-value="isLoading" class="align-center justify-center" z-index="6">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import UserCard from '../../../components/User/Home/UserCard.vue';
import UserInfo from '../../../components/User/Home/UserInfo.vue';
import UserPassword from '../../../components/User/UserPassword.vue';

export default {
    name: 'UserHome',
    components: { UserPassword, UserCard, UserInfo },
    data() {
        return {
            isLoading: true,
            user: {
                id: 0,
                nom: '',
                prenom: '',
                email: '',
                matricule: '',
                etablissement: null,
                role: ''
            }
        };
    },
    created() {
        this.fetchUser();
    },
    methods: {
        fetchUser() {
            this.isLoading = true;
            axios
                .get('user')
                .then((response) => {
                    this.user = response.data.data;
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Erreur',
                        text: error.message
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadingChange(load) {
            this.isLoading = load;
        }
    }
};
</script>

<style scoped>
.admin-page {
    max-width: 100%;
}
.page-header {
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    margin-bottom: 12px;
}
.page-kicker {
    color: #64748b;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 4px;
    text-transform: uppercase;
}
.page-title {
    color: #0f172a;
    font-size: 1.3rem;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.2;
    margin: 0;
}
.theme--dark .page-title {
    color: #f8fafc;
}
.page-subtitle {
    color: #64748b;
    font-size: 0.9rem;
    margin: 4px 0 0;
}
</style>
